<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <h1>Workflows</h1>
      <hr>
      <p>
        <router-link id="btn-new-workflow" :to="{name: 'WorkflowDetail'}" class="btn btn-default"><span class="glyphicon glyphicon-plus"></span> Novo</router-link>
      </p>
      <br/>
      <div class="col-sm-1">
          <b-form-select :options="[{text:5,value:5},{text:10,value:10},{text:15,value:15}]" v-model="perPage" class="input-sm"></b-form-select>
        </div>
        <div class="col-sm-9"></div>
        <div class="col-sm-2">
          <b-form-input v-model="filter" placeholder="Digite para pesquisar" class="input-sm"></b-form-input>
        </div>
      </div>
      <b-table id="workflow-table" :items="workflows" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" striped hover>
        <span slot="active" slot-scope="item">
            {{ item.value ? 'Ativo' : 'Inativo' }}
        </span>
        <span slot="target" slot-scope="item">
            {{ item.value ? item.value.description : '' }}
        </span>
        <span slot="options" slot-scope="item">
            <router-link :to="{name: 'WorkflowDetail', params: {id: item.item.objectId}}" class="btn btn-primary btn-sm">
              <span class="glyphicon glyphicon-edit"></span> Editar
            </router-link>
        </span>
      </b-table>
      <b-pagination size="sm" :total-rows="this.workflows.length" :per-page="perPage" v-model="currentPage"/>
    </div>
  </div>
</template>

<script>

  import { Parse } from '../Global'
  import Loader from './util/Loader'
  import { handleParseError } from './util/ErrorHandling'

  var Workflow = Parse.Object.extend('Workflow')

  export default {
    components: {
      Loader
    },
    data () {
      return {
        workflows: [],
        workflowsParse: [],
        loading: false,
        fields: {
          name: { label: 'Nome', sortable: true },
          active: { label: 'Status', sortable: true },
          target: { label: 'Grupo Alvo', sortable: true },
          startDateFmt: { label: 'Início de Vigência', sortable: true },
          endDateFmt: { label: 'Fim de Vigência', sortable: true },
          createdAtFmt: {label: 'Data de Criação', sortable: true},
          updatedAtFmt: {label: 'Última Atualização', sortable: true},
          options: {label: 'Opções'}
        },
        currentPage: 1,
        perPage: 5,
        filter: null
      }
    },
    mounted () {
      this.refresh()
    },
    methods: {
      refresh () {
        this.loading = true
        let query = new Parse.Query(Workflow)
        query.include('target')
        query.descending('updatedAt')
        let self = this
        query.find({
          success (results) {
            self.workflows = results.map(r => {
              let json = r.toJSON()
              if (json.createdAt) {
                let dtFormat = new Date(json.createdAt)
                json.createdAtFmt = dtFormat.toLocaleString('pt-BR')
              }
              if (json.updatedAt) {
                let dtFormat = new Date(json.updatedAt)
                json.updatedAtFmt = dtFormat.toLocaleString('pt-BR')
              }
              if (json.startDate) {
                let dtFormat = new Date(json.startDate.iso)
                json.startDateFmt = dtFormat.toLocaleString('pt-BR')
              }
              if (json.endDate) {
                let dtFormat = new Date(json.endDate.iso)
                json.endDateFmt = dtFormat.toLocaleString('pt-BR')
              }
              return json
            })
            self.workflowsParse = results
            self.loading = false
          },
          error (obj) {
            handleParseError(self, obj)
            self.loading = false
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WorkflowList.vue?2296a92a